import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../../store/authActions';
import useTitle from '../../hooks/useTitle';
import './AdminLogin.css';

const AdminLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isAuthenticated, loading, error } = useSelector(state => state.auth);
    
    // Задаем название сайта
    useTitle('Авторизация | Админ-панель');

    // Если пользователь уже авторизован, перенаправляем на главную страницу админки
    useEffect(() => {
        if (isAuthenticated) {
            navigate('/performance-admin-panel/products');
        }
    }, [isAuthenticated, navigate]);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        const success = await dispatch(login(username, password));
        if (success) {
            navigate('/performance-admin-panel/products');
        }
    };
    
    return (
        <div className="admin-login-container">
            <div className="login-card">
                <h1 className="login-header">Вход в панель администратора</h1>
                
                {/* {error && (
                    <div className="login-error-message">{error}</div>
                )} */}
                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="username">Логин</label>
                        <input
                            id="username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Введите логин"
                            required
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="password">Пароль</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Введите пароль"
                            required
                        />
                    </div>
                    
                    <button 
                        type="submit"
                        className="login-button"
                        disabled={loading}
                    >
                        {loading ? 'Выполняется вход...' : 'Войти'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;